import { usePortletConfig } from 'js/components/system/Portlet';

const DEFAULT_GAME_COMPONENT_CONFIG = {};

export const useGameComponentConfig = () => {
    const { componentConfiguration } = usePortletConfig();

    return componentConfiguration || DEFAULT_GAME_COMPONENT_CONFIG;
};
